const aws_region = "us-west-2";

const config = {
  appName: "Trust UI - Sandbox",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_SocNqp3Lz`,
    domain: `ispp-trust-co-token-dev.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://ispp-trust-co-token-dev.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "ispp-trust-co-identity-provider",
    redirectUrl: "https://citplanmanager.am.dev.principal.com",
    clientId: "5p9idt72pdrth0adlbvebvgcfr",
    scope: "ispp-trust-co-resource-server/read-write",
    readOnlyGroup: "trust-co-read-only-client",
    updateGroup: "ispp-trust-co-read-write-client",
  },
  api: {
    baseUrl: `https://mg1gctnlf0.execute-api.${aws_region}.amazonaws.com/prod/api`,
  },
};

export default config;
